(app => {

    app.filter("selectedFilters",
        function() {
            const selectedFilters = (arr) => {
                return arr.filter(obj => {
                    return obj.options.some(option => option.selected); 
                });
            }

            return selectedFilters;
        });

})(window.app);